import React, { useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import useScreenSize from "./hooks/useScreenSize";
import { Link } from "react-router-dom";
const Product = ({
  image,
  name,
  tags,
  desc,
  price,
  addToCart,
  maxContentLength = 10,
  classNames = "",
  imageClassNames = "",
}) => {
  const { isLargeScreen } = useScreenSize();
  const [hovered, setHovered] = useState(false);
  const [text, setText] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const containerOverlayClasses = () => {
    if (isLargeScreen() && hovered) {
      return "image-full";
    }
  };
  const actionsOverlayClasses = () => {
    if (!(isLargeScreen() && hovered)) {
      return "lg:hidden";
    }
    if (isLargeScreen() && hovered) {
      return "lg:bg-primary/50";
    }
  };

  const isContentNotTooLong = () => maxContentLength >= text.length;
  const isContentValid = () => isContentNotTooLong() && text.length > 0;
  return (
    <>
      <div
        className={
          "card transition duration-200 ease-in lg:hover:shadow-xl lg:hover:shadow-secondary bg-base-100 shadow-lg rounded-md lg:w-full h-auto hover:rounded-2xl " +
          containerOverlayClasses() +
          " " +
          classNames
        }
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <figure className={imageClassNames + " "}>
          <img
            className="md:h-56 md:rounded-lg lg:w-full lg:h-auto "
            src={image}
            alt={name}
          />
        </figure>
        <div
          className={"card-body z-10  bg-base-100 " + actionsOverlayClasses()}
        >
          <h2 className="card-title text-primary lg:text-base-100">{name}</h2>
          <p className="card-desc text-primary lg:text-base-100 lg:my-4">
            {desc}
          </p>
          <div className="flex gap-2 flex-row h-max">
            {tags.map((tag, i) => (
              <div
                key={i}
                className="badge badge-base-200 lg:border lg:border-secondary lg:bg-transparent h-max md:px-4"
              >
                {tag}
              </div>
            ))}
          </div>
          <div className="card-actions justify-end mt-3">
            <div className="w-full flex align-center place-items-center">
              <p className="text-2xl sm:text-3xl text-primary lg:text-base-100">
                ${price}
              </p>
              <label
                htmlFor={name}
                className="btn add-to-cart-button lg:bg-secondary lg:hover:bg-base-100 lg:text-primary lg:text-base-100 lg:border-base-100 btn-primary flex gap-3"
                // onClick={() => addToCart()}
              >
                <FiShoppingCart size={24} /> Add to Cart
              </label>
            </div>
          </div>
        </div>
      </div>
      <input type="checkbox" id={name} className="modal-toggle z-40" />
      <label
        htmlFor={name}
        className="modal cursor-pointer z-50 modal-wrapper text-primary"
      >
        <label
          className="modal-box relative  z-50"
          // style={{ zIndex: 10000 }}
          htmlFor=""
        >
          <div className="flex">
            <h3 className="text-lg font-bold flex-1">{name} </h3>
            <div className="badge badge-base-200 py-3 text-lg px-4 ">
              ${price}
            </div>
          </div>
          <div className="form-control w-full max-w-xs">
            <label className="label">
              <span className="label-text text-primary">
                What text would you like illustrated?
              </span>
            </label>
            <input
              type="text"
              placeholder="Type here"
              className="input input-bordered w-full max-w-xs focus:border border-primary"
              onChange={(e) => setText(e.target.value)}
            />
            <label className="label">
              <span
                className={`label-text-alt " + ${
                  isContentNotTooLong() ? "" : "text-error"
                }`}
              >
                {isContentNotTooLong()
                  ? `${maxContentLength - text.length} characters remaining`
                  : "That's too many characters, try selecting a larger size to illustrate more characters."}
              </span>
            </label>
          </div>
          <label
            htmlFor={name}
            className={`btn btn-primary flex gap-3 ${
              isContentValid() ? "" : "btn-disabled"
            }`}
            onClick={() => {
              addToCart(text);
              setShowSuccess(true);
            }}
          >
            <FiShoppingCart size={24} /> Add to Cart
          </label>
        </label>
      </label>
      {showSuccess && (
        <div className="toast toast-end toast-bottom z-40 font-secondary ">
          <div className="alert glass rounded-md relative ">
            <div className="absolute w-full left-0 top-0 rounded-md h-full bg-secondary opacity-50"></div>

            <div className="z-50 flex sm:gap-4">
              <span>"{name}" Successfully added to cart.</span>
              <div className="flex justify-end gap-2 flex-col sm:flex-row">
                <button
                  onClick={() => setShowSuccess(false)}
                  className="btn btn-outline btn-primary font-secondary"
                >
                  Keep Shopping
                </button>

                <Link
                  to="./checkout"
                  className="btn btn-primary font-secondary"
                >
                  Go to cart
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Product;
